import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
interface GaugeChartProps {
  value: number; // 0-100
}
export const GaugeChart: React.FC<GaugeChartProps> = ({
  value
}) => {
  const data = [{
    name: 'Completed',
    value: value
  }, {
    name: 'Remaining',
    value: 100 - value
  }];
  const getColor = (value: number) => {
    if (value >= 80) return '#10B981'; // green
    if (value >= 50) return '#F59E0B'; // yellow
    return '#EF4444'; // red
  };
  return <div className="relative h-full w-full flex items-center justify-center" data-id="element-34">
      <ResponsiveContainer width="100%" height="100%" data-id="element-35">
        <PieChart data-id="element-36">
          <Pie data={data} cx="50%" cy="50%" startAngle={180} endAngle={0} innerRadius="60%" outerRadius="80%" paddingAngle={0} dataKey="value" data-id="element-37">
            <Cell key="cell-0" fill={getColor(value)} data-id="element-38" />
            <Cell key="cell-1" fill="#374151" data-id="element-39" />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex items-center justify-center flex-col" data-id="element-40">
        <span className="text-3xl font-bold" data-id="element-41">{value}%</span>
        <span className="text-sm text-gray-400" data-id="element-42">Auslastung</span>
      </div>
    </div>;
};